<div class="menu-wrapper">
  <a
    *ngFor="let item of menuItems"
    routerLink="{{ item.routerLink }}"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    class="menu-link"
  >
    <div class="menu-link-title">{{ item.title | translate }}</div>
  </a>
</div>
